import { Badge } from '@mantine/core'
import { IconCheck, IconLoader, IconX } from '@tabler/icons-react'
import { cloneElement } from 'react'
import { FormattedMessage } from 'react-intl'
import { ConnectionStatus } from '../useTestConnectionStatus'

const connectionStatusMap = {
  ok: {
    icon: <IconCheck />,
    color: 'green',
    message: 'integrations.connectionStatus.ok'
  },
  error: {
    icon: <IconX />,
    color: 'red',
    message: 'integrations.connectionStatus.error'
  },
  pending: {
    icon: <IconLoader />,
    color: 'gray',
    message: 'integrations.connectionStatus.pending'
  }
}

type ConnectionStatusBadgeProps = {
  status: ConnectionStatus
  detail?: string
}

export const ConnectionStatusBadge = ({
  status,
  detail
}: ConnectionStatusBadgeProps) => {
  if (!status) {
    return null
  }

  const { icon, color, message } = connectionStatusMap[status]

  return (
    <Badge
      variant="light"
      leftSection={cloneElement(icon, { size: 14 })}
      color={color}
    >
      {detail ? detail : <FormattedMessage id={message} />}
    </Badge>
  )
}
